module.exports = __webpack_public_path__ + "img/prize-01.8a1dc455.png";